"use client"

import Image from "next/image"

/**
 * HumanFirewall AI product mark at the top of EVERY sidebar — the tenant app
 * and the super-admin area render this one component, so the two shells can't
 * drift (the admin sidebar had no logo until 2026-09-15).
 *
 * Expanded-only. Ships as a light/dark pair rather than one asset under a
 * brightness filter: the "beta" badge is white with a black keyline, and
 * brightness-0 would flatten it to a solid black slug on the light sidebar
 * (it was also flattening the red "Firewall" half). Same swap pattern as
 * <PlayerBrandLogo>. Set at h-8 — the mark is 207px wide there against the
 * ~240px a 16rem rail leaves after px-2, and "beta" stops being legible below
 * that. Regenerate via apps/api/scripts/generate-ai-beta-logo.mjs.
 */
export function SidebarBrandMark() {
  return (
    <div className="flex items-center justify-start px-2 pt-1.5 pb-1 group-data-[collapsible=icon]:hidden">
      <Image
        src="/brand/humanfirewall-ai-beta-light.svg"
        alt="HumanFirewall AI beta"
        width={207}
        height={32}
        priority
        className="block h-8 w-auto dark:hidden"
      />
      <Image
        src="/brand/humanfirewall-ai-beta.svg"
        alt="HumanFirewall AI beta"
        width={207}
        height={32}
        priority
        className="hidden h-8 w-auto dark:block"
      />
    </div>
  )
}
